import { j as e } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import { g as y } from "../../chunks/groupBy.BfGV0C80.js";
import { useMemo as m } from "react";
import { B as C } from "../../chunks/Button.Ccj-dDdM.js";
import { S as D } from "../../chunks/Spinner.Brgz0Lk4.js";
import { T as a } from "../../chunks/Text.BGhoO_e3.js";
import { D as v, k as N, d as A, g as E, j as S, e as B, b as M, f as O } from "../../chunks/Dialog.CH2ZNDp8.js";
import { c as T } from "../../chunks/index.CxSWpsOB.js";
import { u as k, C as L } from "../../chunks/IntlGlobalMessages.DP29fCHC.js";
const R = (s) => ({
  "en-us": "US",
  "en-gb": "GB",
  "fr-fr": "FR",
  "fr-ca": "CA",
  "es-es": "ES",
  "de-de": "DE",
  "en-ca": "CA",
  "en-au": "AU"
})[s] || s, I = ({
  activeLocales: s,
  profileUpdateLoading: i,
  profileUpdateHasError: g,
  currentLocale: o,
  onSelectLocale: p,
  intl: w,
  buttonClassNames: u,
  trigger: l,
  open: b,
  onOpenChange: x
}) => {
  const {
    formatComponentMessage: n
  } = k(L.LOCALE_SELECTOR, w), c = m(() => Object.keys(s).map((t) => ({
    ...s[t],
    locale: t
  })), [s]), d = m(() => {
    const t = c.filter((r) => r.region);
    return y(t, "region");
  }, [c]), h = s[o], f = R(o.toLowerCase()), j = h.language;
  return /* @__PURE__ */ e.jsxs(v, { open: b, onOpenChange: x, children: [
    /* @__PURE__ */ e.jsx(N, { asChild: !0, children: l || /* @__PURE__ */ e.jsx(C, { "data-testid": "locale-selector-trigger", variant: "underline", className: u, children: `${j} (${f})` }) }),
    /* @__PURE__ */ e.jsxs(A, { id: "locale-selector-modal", "data-testid": "locale-selector-modal", size: "lg", children: [
      /* @__PURE__ */ e.jsxs(E, { showCloseButton: !0, children: [
        /* @__PURE__ */ e.jsx(S, { children: n("header") }),
        /* @__PURE__ */ e.jsx(B, { children: n("subheader") })
      ] }),
      /* @__PURE__ */ e.jsx(M, { children: i ? /* @__PURE__ */ e.jsx("div", { className: "tw-flex tw-justify-center tw-items-center tw-h-full tw-my-28", children: /* @__PURE__ */ e.jsx(D, { appearance: "black" }) }) : /* @__PURE__ */ e.jsxs("div", { children: [
        g && /* @__PURE__ */ e.jsx(a, { className: "tw-text-brand-red tw-text-center tw-w-full", children: n("error_msg") }),
        Object.keys(d).map((t) => /* @__PURE__ */ e.jsxs("div", { className: "tw-mb-40", children: [
          /* @__PURE__ */ e.jsx(a, { typeface: "body-2-m", className: "tw-mb-16", children: t }),
          /* @__PURE__ */ e.jsx("div", { className: "tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 tw-gap-16", children: d[t].map((r) => /* @__PURE__ */ e.jsxs("button", { "data-testid": `locale-selector-button-${r.locale}`, onClick: () => p(r), className: T("tw-text-left tw-w-full tw-bg-transparent tw-border tw-border-gray-400 tw-py-8 tw-px-16 tw-rounded-4 tw-shadow-none hover:tw-bg-gray-200", {
            "tw-bg-purple-600 tw-text-base-white hover:tw-bg-purple-700": r.locale === o
          }), children: [
            /* @__PURE__ */ e.jsx(a, { element: "div", typeface: "body-2-m", children: r.language }),
            /* @__PURE__ */ e.jsx(a, { element: "div", typeface: "body-2", children: r.country })
          ] }, r.country)) })
        ] }, t))
      ] }) }),
      /* @__PURE__ */ e.jsx(O, {})
    ] })
  ] });
};
export {
  I as LocaleSelectorModal
};
//# sourceMappingURL=index.js.map
